import {
    GET_EXAM_BOARDS_SUCCESS,
    GET_EXAM_BOARDS_FAILED
} from './actionTypes'

const INIT_STATE = {
    examboards: [],
    error: "",
    form_errors: []
}

const ExamBoardsReducer = (state = INIT_STATE, { type, payload }) => {
    
    switch (type) {
        
        case GET_EXAM_BOARDS_SUCCESS: {
            return {
                ...state,
                examboards: payload
            }
        }

        case GET_EXAM_BOARDS_FAILED: {
            return {
                ...state,
                error: payload
            }
        }
        default:
            return state
    }
}

export default ExamBoardsReducer